import { Variable } from '@ff-scene-plugins/gift-shared/Variable';
import { textToFfCanvas } from '@gift-variable-plugins/text-shared/textToFfCanvas';
import { TextVariableInput } from '@gift-variable-plugins/text-shared/TextVariableInput';
import { TextVariableOptions } from '@gift-variable-plugins/text-shared/TextVariableOptions';
import { TextInputControl } from './TextInputControl';

export const textPdpPlugin: Variable.Plugin<TextVariableOptions, TextVariableInput> = {
    pluginId: 'text',
    InputControl: TextInputControl,
    toFfCanvas: textToFfCanvas
};